<template>
  <v-dialog
      v-model="showDialog"
      max-width="400px"
      persistent
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Ab wann soll die Arbeitszeit gelten ?</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col md="4">
              <label class="v-label theme--light" style="margin-top: 10px">Beginn:</label>
            </v-col>
            <v-col>
              <datetime
                  style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                  v-model="phaseStart"
                  input-class="form-control text-center"
                  input-style="color: black;"
                  :phrases="datetimeConfig.phrases"
                  :format="{  month: 'long', day: '2-digit' }"
                  :min-datetime="datetimeConfig.minTime"
                  :max-datetime="datetimeConfig.maxTime"
                  hide-year></datetime>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="showDialog = false; $emit('cancel')"
        >
          Abbrechen
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            @click="submit"
        >
          Beginn setzen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import {v4} from "uuid";
import {DateTime as LuxonDateTime} from "luxon";

export default {
  name: "azra_begin_dialog",
  props: {
  },
  data () {
    return {
      showDialog: false,
      phaseStart: null,
      datetimeConfig: {
        phrases: {ok: 'Ok', cancel: 'Abbruch'},
        minTime: LuxonDateTime.local(LuxonDateTime.local().year, 1, 1, 12).toISO(),
        maxTime: LuxonDateTime.local(LuxonDateTime.local().year, 12, 31, 12).toISO(),
      },
      error: false,
    }
  },
  computed: {
  },
  watch: {
    phaseStart(newValue) {
      console.log(newValue)
    }
  },
  methods: {

    show() {
      this.phaseStart = LuxonDateTime.local().toISO();
      console.log(this.phaseStart)
      this.showDialog = true;
    },
    submit() {
      this.$emit('submit', this.phaseStart.substring(0, 10));
      this.showDialog = false;
    }
  }
}
</script>

<style scoped>

</style>
